import styled from "styled-components";
import { Layout as AntdLayout } from "antd";

export const IconButtonWrapper = styled.div`
  color: #9ba2b0;
  font-size: 14px;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 48px;
  width: max-content;
  position: relative;
  > span {
    margin-left: 6px;
  }
  > svg:last-child {
    margin-left: 10px;
  }
  .message-icon {
    display: flex;
    position: relative;
  }
`;

export const Layout = styled(AntdLayout)`
  .ant-layout {
    background-color: #17181c;
  }
  .ant-layout-header {
    background-color: #262729;
  }
  .ant-layout-sider {
    background-color: #262729;
  }
`;
export const RedRadio = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #d94a41;
  position: absolute;
  left: 12px;
  top: 13px;
`;

export const LogoWrap = styled.div`
  width: 77px;
`;
